import React from "react";
// import House from "../../Assets/images/apa1.png";
import StarRateIcon from "@mui/icons-material/StarRate";

function Allapartmentcom({ onDetailsClick, data }) {
  return (
    <div className="bg-white border border-gray-100 shadow-md rounded-xl p-3 flex gap-4 mb-4">
      <img
        src={data?.apartmentClassImagesDTOS?.[0]?.imageUrl || data?.images?.[0]}
        alt=""
        className="w-[110px] h-[110px] rounded-lg object-cover flex-shrink-0"
      />

      <div className="flex flex-col flex-1 py-1">
        <div className="flex justify-between items-start mb-1">
          <div className="flex flex-col md:flex-row gap-2 md:items-center">
            <h3 className="text-[#1E222B] font-[600] text-[18px] leading-tight">
              {data?.apartmentName}
            </h3>
            <span className="text-[#00BC67] bg-[#E6F8F0] px-2 py-1 rounded text-[11px] font-[600] tracking-wide w-fit mt-1 md:mt-0">
              {data?.rentAvailability || "Available"}
            </span>
          </div>
          {/* <div className="flex items-center gap-1 whitespace-nowrap ml-2">
            <StarRateIcon className="text-[#A3D133]" fontSize="small" />
            <span className="text-[#1E222B] text-[13px] font-[500]">
              4.0 (26)
            </span>
          </div> */}
        </div>
        <p className="text-[#1E222B] font-[600] text-[16px] mb-1">
          {`(Room ${data.bedRooms})`}
        </p>
        <p className="text-[#1E222B] text-[12px] leading-snug line-clamp-2 mt-1">
          {data?.apartmentClassDetails}
        </p>

        <div className="flex justify-between items-end mt-auto">
          <p className="text-[#00BC67] font-[700] text-[16px]">
            NGN{data?.price?.toLocaleString()}
            <span className="text-[#808285] font-[500] text-[16px]">/year</span>
          </p>
          <button
            onClick={onDetailsClick}
            className="border border-[#D5D5D6] text-[#00BC67] hover:bg-[#E6F8F0] transition-colors font-[500] text-[14]px] py-2 px-5 rounded-md"
          >
            Details
          </button>
        </div>
      </div>
    </div>
  );
}

export default Allapartmentcom;
